import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

/**
 * 🔹 Payload para crear/actualizar
 */
export interface CapacitacionActividadPayload {
  id_capacitacion: number;
  dirigido: number;
  responsable: number;
  fecha_programacion: string; // formato YYYY-MM-DD
  fecha_ejecucion: string;    // formato YYYY-MM-DD
  hora_inicio: string;
  hora_fin: string,
  estado?: number;
}
 
/**
 * 🔹 Interface de respuesta / registro completo
 */
export interface CapacitacionActividad {
  id?: number;
  id_capacitacion: number;
  dirigido: number;
  responsable: number;
  fecha_programacion: string;
  fecha_ejecucion: string;
  hora_inicio: string;
  hora_fin: string;
  estado: number;
  fechaCreacion?: string;
  fechaModificacion?: string | null;
  capacitacion?: {
    nombre?: string;
    tema?: string;
  };
}
 
export interface CapacitacionActividadResponse {
  id?: number;
  message?: string;
  error?: string;
  data?: any;
  [key: string]: any;
}
 
@Injectable({
  providedIn: "root",
})
export class CapacitacionActividadService {
  private readonly apiUrl = `${environment.apiUrl}/api/capacitacion_actividad`;

  constructor(private http: HttpClient) {}

  // Listar todas las actividades de capacitación
  getAll(): Observable<CapacitacionActividad[]> {
    return this.http.get<CapacitacionActividad[]>(this.apiUrl, { withCredentials: true });
  }

  // Obtener por ID
  getById(id: number): Observable<CapacitacionActividad> {
    return this.http.get<CapacitacionActividad>(`${this.apiUrl}/${id}`, { withCredentials: true });
  }


 getByIdCapacitacion(id_capacitacion: number): Observable<CapacitacionActividad[]> {
      return this.http.get<CapacitacionActividad[]>(`${this.apiUrl}/capacitacion/${id_capacitacion}`, { withCredentials: true });
    }

  // Crear nueva actividad de capacitación
  create(payload: CapacitacionActividadPayload): Observable<CapacitacionActividadResponse> {
    return this.http.post<CapacitacionActividadResponse>(this.apiUrl, payload, { withCredentials: true });
  }

  // Actualizar actividad de capacitación
  update(id: number, payload: Partial<CapacitacionActividadPayload>): Observable<CapacitacionActividadResponse> {
    return this.http.put<CapacitacionActividadResponse>(`${this.apiUrl}/${id}`, payload, { withCredentials: true });
  }

  // Eliminar actividad de capacitación (DELETE)
  remove(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${id}`, { withCredentials: true });
  }

  // Inactivar actividad de capacitación
  inactivar(id: number): Observable<CapacitacionActividadResponse> {
    return this.http.put<CapacitacionActividadResponse>(`${this.apiUrl}/${id}/inactivar`, {}, { withCredentials: true });
  }

  // Activar actividad de capacitación
  activar(id: number): Observable<CapacitacionActividadResponse> {
    return this.http.put<CapacitacionActividadResponse>(`${this.apiUrl}/${id}/activar`, {}, { withCredentials: true });
  }
}